import React from 'react'
import {
  STATUS_MAP,
  STATUS_DRAFT,
  STATUS_NOT_START,
  WCD_ROUTE_EDIT,
  WCD_ROUTE_DATA,
  WCD_ROUTE_AD
} from '../../constant'
import { isJuKeActivity, goWcdPath, goCopyWcd } from '../../util'
import style from './style.module.less'
import { Flex } from 'hljd'
import OperatorList from '@common/OperatorList'

export default store => {
  return [
    {
      title: '活动标题',
      dataIndex: 'name',
      width: 300,
      render: (
        name,
        { id, finderActivityId, startDate, endDate, isSetDate, status }
      ) => {
        const juKeActivity = isJuKeActivity(finderActivityId)
        const dom = status != 0 && '未限制活动周期'
        return (
          <div>
            <Flex vc>
              {juKeActivity && <span className={style.juke}>聚客宝</span>}

              <span
                className={style.name}
                onClick={() => {
                  if (!juKeActivity) {
                    goWcdPath(WCD_ROUTE_EDIT, id)
                  }
                }}
              >
                {name}
              </span>
            </Flex>

            <div className={style.date}>
              {isSetDate ? (
                <>
                  {startDate} - {endDate}
                </>
              ) : (
                dom
              )}
            </div>
          </div>
        )
      }
    },
    {
      title: '缩略图',
      dataIndex: 'picture',
      width: 160,
      render: picture => {
        return (
          <img
            className={style.activit_cover}
            src={picture + '?imageView2/1/w/150/h/150'}
          />
        )
      }
    },
    {
      title: '报名人数',
      dataIndex: 'signUpCount',
      width: 120,
      render: (signUpCount, { id, status }) => {
        if (status == STATUS_DRAFT || status == STATUS_NOT_START) {
          return '—'
        }

        return (
          <a
            onClick={() => {
              goWcdPath(WCD_ROUTE_DATA, id)
            }}
          >
            {signUpCount}
          </a>
        )
      }
    },
    {
      title: '活动状态',
      dataIndex: 'status',
      width: 120,
      render: status => {
        return STATUS_MAP[String(status)]
      }
    },
    {
      title: '更新时间',
      dataIndex: 'updatedAt',
      width: 180
    },
    {
      title: '操作',
      dataIndex: 'id',
      width: 300,
      render: (id, { finderActivityId, status }) => {
        const Edit = (
          <a
            onClick={() => {
              goWcdPath(WCD_ROUTE_EDIT, id)
            }}
          >
            编辑活动
          </a>
        )

        const Setting = (
          <a
            onClick={() => {
              goWcdPath(WCD_ROUTE_AD, id)
            }}
          >
            投放设置
          </a>
        )

        const Data = (
          <a
            onClick={() => {
              goWcdPath(WCD_ROUTE_DATA, id)
            }}
          >
            数据统计
          </a>
        )

        const Copy = (
          <a
            onClick={() => {
              goCopyWcd(id)
            }}
          >
            复制
          </a>
        )

        const Delete = <a onClick={() => store.delActivity(id)}>删除</a>

        let btns = [Edit, Setting, Data, Copy, Delete]

        if (status == STATUS_DRAFT) {
          btns = [Edit, Copy, Delete]
        }

        if (isJuKeActivity(finderActivityId)) {
          btns = [Setting, Data, Copy]
        }

        return <OperatorList list={btns} />
      }
    }
  ]
}
